import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Fan } from "lucide-react";

interface IEvaporativeCooler {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function EvaporativeCooler(props: IEvaporativeCooler) {
    const { value, onChange, loading } = { ...props };
    const [hasCooler, setHasCooler] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setHasCooler(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setHasCooler(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Evaporative Cooler
            </Typography>

            <Select
                placeholder="Has evaporative cooler?"
                value={hasCooler}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Fan size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="No">No</Option>
                <Option value="Yes">Yes</Option>
            </Select>
        </Box>
    );
}
